var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_950_5261",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_950_5261",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACYElEQVR4nO2ZTahNURTHfz6KlOQjb6B8DEiEiZHyKG/mkpKBuZAiA2VgQHmJepQhGcjAZxQy81GKCaWMiDJCr/S89+57no/H0a7/0Wq3z7n3navOOa/9r3933732WWf991prt7sXIiIiIiJKxjbgCTACJBXnCPAYaPgiTlUguKLstZlIas4GKqek5nzkhDQrEEinHKYCQfwvUnYAUQgxI5RePknsESZRRsaAAfGHZxsw/JlxJ0rtwxk+QxwK+Bo19j9FhLgrTIo9/sMGRzybe9lKY99sbCdaXGCnAffM+ndAl2z7imTEOZgKzJKTmUB/hpA53k7e9ewhIYuBHo/rZZsNvAI+Aks1txMYLyLkoBwcArZofDwgZJ0+zxlbt+ZW5Ag5HHjnbwXssAhYo/EmleSEe2RQuzIFeKNUOyw0DlNc1ucS4BfwwmTwfI6Q5cAujx+Ab8AG438t8LVos5+Vk2XATeC6hDlc9IR8AlZr7Nbt1ngvcC1HyAxgrsfXKp/txn9PxmHSUsi4qcsQVqmZU3wGLmnsGny6euttCyGh0kqA/bLPB+ZlHDRtCbltavSoxwWyPfCEjKnsUuyQrzwhru8ueDwgmztgngNPlTmHMxMVslEP9gVsx0y6rRD/WH3WhpC84/eOWX9Dvep4tV0h383uDAbs/YFdHJXti75fMevfa+6+mXsZ8GH5MPDeW8BpHR6hIzi37upEyg4gCiFmhNLLJ4k9Qvk7ncSMUNOMNCsQRKccQv8zJJPhR+xGBQLplFvT22ZvBYIpypP+1bmhFNWhZ5qK9V8mIiIiIiIoA38B/DctQGj39wAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.c03db7dfd7ed022c258a443b0144bf5f.svg";
export { ForwardRef as ReactComponent };